var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.998 8V56.8889",
    stroke: "#DA5107",
    strokeWidth: 4.44444,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1105 16.8906H26.4438C24.381 16.8906 22.4027 17.7101 20.9441 19.1687C19.4855 20.6273 18.666 22.6056 18.666 24.6684C18.666 26.7312 19.4855 28.7095 20.9441 30.1681C22.4027 31.6267 24.381 32.4462 26.4438 32.4462H37.5549C39.6177 32.4462 41.596 33.2656 43.0546 34.7242C44.5132 36.1829 45.3327 38.1612 45.3327 40.224C45.3327 42.2868 44.5132 44.2651 43.0546 45.7237C41.596 47.1823 39.6177 48.0017 37.5549 48.0017H18.666",
    stroke: "#DA5107",
    strokeWidth: 4.44444,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingManagement);
export default __webpack_public_path__ + "static/media/pricing-management.aab6cb82bbe306805bc7ec46ff29ba2f.svg";
export { ForwardRef as ReactComponent };